import iconTrash from '../../../../../assets/images/icon_trash.svg'
import { IconButton } from '../../../IconButton'

interface IDeleteButtonProps {
  onClickDelete: () => void
  size?: number
}

export const DeleteButton = ({ onClickDelete, size }: IDeleteButtonProps) => {
  return (
    <IconButton
      icon={iconTrash}
      size={size ?? 12}
      onClick={onClickDelete}
      style={{
        right: '0px',
        bottom: 'auto',
        boxShadow: 'none',
      }}
    />
  )
}
